import EnrollmentSteps from 'components/EnrollmentSteps/EnrollmentSteps';
import { Header } from 'components/Header/Header';

export default function DwollaApp({ store }: any) {
  return (
    <>
      <Header />
      {/*
        `bg-gray-950` no pintaba nada: la escala `gray` no existia en
        `tailwind.config.js`, asi que la clase no generaba regla y el fondo
        quedaba a cargo del navegador. Ahora usa el token de fondo de pagina,
        que ademas cambia solo entre tema claro y oscuro.
      */}
      <div
        style={{
          height: '100%',
          minHeight: '100vh',
          maxHeight: '100%',
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
        }}
        className='bg-background'
      >
        <EnrollmentSteps />
      </div>
    </>
  );
}
